export const isAtLeast8Chars = (value: string) => /.{8,}/.test(value);
export const hasUppercase = (value: string) => /[A-Z]/.test(value);
export const hasLowercase = (value: string) => /[a-z]/.test(value);
export const hasSpecialChar = (value: string) =>
  /[!@#$%^&*(),.?":{}|<>]/.test(value);
